import { render, staticRenderFns } from "./ButtonIcon.vue?vue&type=template&id=eccb00c0"
import script from "./ButtonIcon.vue?vue&type=script&lang=js"
export * from "./ButtonIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Icon: require('/srv/app/components/icon/Icon.vue').default})
